import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FadeIn from 'react-fade-in';
import JBImage from 'components/essentials/JBImage';
import useScreen from 'hooks/useScreen';
const PDPReviewsMaterialFlyout = t0 => {
  const $ = _c(36);
  const {
    align: t1,
    className: t2,
    content,
    headerBgColor: t3,
    imageUrl,
    subSubTitle,
    subTitle,
    title,
    top,
    left
  } = t0;
  const align = t1 === undefined ? "left" : t1;
  const className = t2 === undefined ? "" : t2;
  const headerBgColor = t3 === undefined ? null : t3;
  const containerRef = useRef(null);
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);
  const {
    isMobile
  } = useScreen();
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setTimeout(() => {
        setIsAnimationComplete(true);
      }, 100);
    };
    t5 = [];
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  useEffect(t4, t5);
  let t6;
  if ($[2] !== headerBgColor || $[3] !== imageUrl || $[4] !== isMobile) {
    t6 = imageUrl && !isMobile && <div className={cx("w-screen relative [&_img]:h-[156px] [&_img]:object-cover lg:w-auto [&_svg]:absolute [&_svg]:bottom-4 [&_svg]:right-4", {
      "w-auto px-0 py-2 bg-gray-light7 [&_img]:object-contain": headerBgColor === "grey"
    })}><JBImage src={imageUrl} width={400} loader={false} lazy={false} /></div>;
    $[2] = headerBgColor;
    $[3] = imageUrl;
    $[4] = isMobile;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== title) {
    t7 = <div className="text-xl flex font-bold">{title}</div>;
    $[6] = title;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== subSubTitle || $[9] !== subTitle) {
    t8 = !!subTitle || !!subSubTitle ? <div className="mb-4">{subTitle ? <span className="PDPReviewsMaterialFlyout__subTitle">{" "}{subTitle}{" "}</span> : null}{subSubTitle ? <div className="PDPReviewsMaterialFlyout__subSubTitle">{" "}{subSubTitle}{" "}</div> : null}</div> : null;
    $[8] = subSubTitle;
    $[9] = subTitle;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== content) {
    t9 = <div className="text-xs text-gray text-left">{content}</div>;
    $[11] = content;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div className="text-xs pt-6 px-2 pb-0 lg:border lg:border-solid lg:border-gray-light7 lg:rounded-bl-lg lg:rounded-br-lg lg:p-8">{t7}{t8}{t9}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6) {
    t11 = <>{t6}{t10}</>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const containerContent = t11;
  let t12;
  if ($[20] !== left || $[21] !== top) {
    t12 = {
      top,
      left
    };
    $[20] = left;
    $[21] = top;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = align === "left";
  const t14 = align === "right";
  let t15;
  if ($[23] !== className || $[24] !== t13 || $[25] !== t14) {
    t15 = cx("w-[400px] min-h-[255px] bg-white ml-[1.9rem] rounded-lg overflow-hidden", className, {
      "PDPReviewsMaterialFlyout-align-left": t13,
      "PDPReviewsMaterialFlyout-align-right": t14
    });
    $[23] = className;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = !isAnimationComplete ? "hidden" : undefined;
  let t17;
  if ($[27] !== t16) {
    t17 = {
      visibility: t16
    };
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== containerContent || $[30] !== t15 || $[31] !== t17) {
    t18 = <FadeIn><div ref={containerRef} className={t15} style={t17}>{containerContent}</div></FadeIn>;
    $[29] = containerContent;
    $[30] = t15;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t12 || $[34] !== t18) {
    t19 = <div className="fixed z-[1000]" style={t12}>{t18}</div>;
    $[33] = t12;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  return t19;
};
PDPReviewsMaterialFlyout.propTypes = {
  align: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  content: PropTypes.string,
  headerBgColor: PropTypes.oneOf(['grey']),
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  top: PropTypes.number,
  subTitle: PropTypes.node,
  subSubTitle: PropTypes.node,
  left: PropTypes.number
};
export default PDPReviewsMaterialFlyout;